import { Menu } from 'lucide-react';
import { NavLink } from 'react-router';
import { NAVIGATION } from '@/shared/config/navigation';
import { useTranslation } from '@/shared/i18n/use-translation';
import { cn } from '@/shared/lib/cn';
import { useSidebar } from '@/shared/ui/sidebar/use-sidebar';

const ITEM =
  'group flex h-16 flex-col items-center justify-center gap-1 text-xs font-medium text-muted-foreground';
const PILL = 'flex h-7 w-14 items-center justify-center rounded-full transition-colors';

/** Phones: the four main sections, and "More", which opens the sidebar as a sheet. */
export function BottomNav() {
  const { t } = useTranslation();
  const { openMobile, setOpenMobile } = useSidebar();
  return (
    <nav
      className="fixed inset-x-0 bottom-0 z-30 grid grid-cols-5 border-t bg-background/92 pb-[env(safe-area-inset-bottom)] backdrop-blur-md md:hidden"
      aria-label={t('Sections')}
    >
      {NAVIGATION.filter((item) => item.primary).map(({ to, label, icon: Icon }) => (
        <NavLink
          key={to}
          to={to}
          end={to === '/'}
          className={({ isActive }) => cn(ITEM, isActive && 'text-foreground')}
        >
          {({ isActive }) => (
            <>
              <span className={cn(PILL, isActive && 'bg-accent text-accent-foreground')}>
                <Icon className="size-5" />
              </span>
              {t(label)}
            </>
          )}
        </NavLink>
      ))}
      <button
        type="button"
        className={cn(ITEM, openMobile && 'text-foreground')}
        aria-expanded={openMobile}
        onClick={() => setOpenMobile(true)}
      >
        <span className={cn(PILL, openMobile && 'bg-accent text-accent-foreground')}>
          <Menu className="size-5" />
        </span>
        {t('More')}
      </button>
    </nav>
  );
}
